import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppUser } from '../_models/AppUser';
import { Configuration } from '../../shared/configuration/Configuration';
import { AppState } from '../../appstate.model';

@Injectable()
export class UserService {
  config: Configuration;
  constructor(
    private httpClient: HttpClient,
    private store: Store<AppState>,
  ) {
    this.store
      .select((x) => x.Configuration)
      .subscribe((x) => {
        this.config = x;
      });
  }

  /** Gets the AppUser for the currently logged in user */
  getCurrent(): Observable<AppUser> {
    return this.httpClient.get<AppUser>(
      `${this.config.carrierServiceUrl}user/current`,
    );
  }

  /** Do anything needed in carrier api when user logs out. */
  getCurrentUserUserLogout() {
    return this.httpClient.get(`${this.config.carrierServiceUrl}user/logout`);
  }
}
